// extracted by mini-css-extract-plugin
export default {"pageContainer":"FacultyEnrollment_pageContainer__T9B5i","card":"FacultyEnrollment_card__WYoRe","title":"FacultyEnrollment_title__otTxU"};